import { TrainingProgramTypes } from "./TrainingProgram"

export const FellowshipPrograms : ReadonlyArray<TrainingProgramTypes> = [
    TrainingProgramTypes.ClinicalNeurophysiology,           // Id 105
    TrainingProgramTypes.VascularNeurology,                 // Id 106
    TrainingProgramTypes.AddictionPsychiatry,               // Id 108
    TrainingProgramTypes.ForensicPsychiatry,                // Id 111
    TrainingProgramTypes.GeriatricPsychiatry,               // Id 112
    TrainingProgramTypes.PsychosomaticMedicine,             // Id 113
    TrainingProgramTypes.SleepMedicine,                     // Id 114
    TrainingProgramTypes.NeuromuscularMedicine,             // Id 120
    TrainingProgramTypes.PainMedicine,                      // Id 123
    TrainingProgramTypes.HospiceAndPalliativeMedicine,      // Id 124
    TrainingProgramTypes.Epilepsy,                          // Id 162
];
